import EcommerceViewModeEnum from "../../../models/EcommerceViewModeEnum";
import OwButton from "../../shared/OwButton/OwButton";
import "./EcommerceViewToggle.scss";

type Props = {
    viewMode: EcommerceViewModeEnum;
    onChange: (mode: EcommerceViewModeEnum) => void;
};

export const EcommerceViewToggle = (props: Props) => {
    const isCard = props.viewMode === EcommerceViewModeEnum.CARD;
    const isList = props.viewMode === EcommerceViewModeEnum.LIST;
    const isQuick = props.viewMode === EcommerceViewModeEnum.QUICK;

    return (
        <div className={"EcommerceViewToggle"}>
            <div className={"btn-group"}>
                <OwButton
                    className={"btn-primary " + (isCard ? "active" : "")}
                    hoverTitle={"Card View"}
                    ariaLabel={"Card View"}
                    centerIconClass={"fad fa-th-large"}
                    fn={() => props.onChange(EcommerceViewModeEnum.CARD)}
                />
                <OwButton
                    className={"btn-primary " + (isList ? "active" : "")}
                    hoverTitle={"List View"}
                    ariaLabel={"List View"}
                    centerIconClass={"fad fa-list"}
                    fn={() => props.onChange(EcommerceViewModeEnum.LIST)}
                />
                <OwButton
                    className={"btn-primary " + (isQuick ? "active" : "")}
                    hoverTitle={"Quick Order"}
                    ariaLabel={"Quick Order"}
                    centerIconClass={"fad fa-keyboard"}
                    fn={() => props.onChange(EcommerceViewModeEnum.QUICK)}
                />
            </div>
        </div>
    );
};

export default EcommerceViewToggle;
